<template>
  <va-card :title="$t('users.listTitle')">
    <div class="row flex-end">
      <div class="mr-auto flex sm12 xl4 xs12">
        <va-input v-model="searchValue" :label="!searchBy ? $t('users.searchValue') : ''" :style="{ width: '100%' }"
          :disabled="!searchBy" :placeholder="
            !searchBy ? $t('users.selectSearchBy') : $t('users.searchValue')
          ">
          <va-select class="serchby" slot="prepend" :label="$t('users.searchBy')" v-model="searchBy"
            :clearValue="{ name: '' }" @input="searchValue = ''" :options="[
              'first_name',
              'last_name',
              'phone',
              'bio',
              'email',
              'zip'
            ]" />
        </va-input>
      </div>
      <div class="ml-auto flex sm6 md4 xl3 xs12">
        <va-select :label="$t('users.orderBy')" v-model="orderBy" textBy="title" keyBy="name" :clearValue="{ name: '' }"
          :options="
            fields
              .filter(e => !!e.title)
              .map(e => ({
                name: e.name.replace('__slot:', ''),
                title: e.title
              }))
          " />
      </div>
      <div class="flex sm6 md4 xl3 xs12">
        <va-select :label="$t('users.perPage')" v-model="perPage" noClear :options="['10', '20', '50', '100', '200']" />
      </div>
      <div class="flex sm6 md4 xl2 xs12">
        <va-button @click="getSvcUsers" style="white-space: nowrap;">export csv</va-button>
      </div>
    </div>
    <va-data-table ref="vuetable" :fields="fields" :data="items" :loading="loading && !skipLoading"
      :totalPages="totalPages" @page-selected="readItems" api-mode>
      <template slot="avatar" slot-scope="props">
        <va-icon v-if="props.rowData.avatar === null" name="vuestic-iconset vuestic-iconset-user" :size="40"></va-icon>
        <img v-else :src="props.rowData.avatar" class="users__avatar" />
      </template>
      <template slot="profits" slot-scope="props">
        <div>
          {{ props.rowData.profits }}$
        </div>
      </template>
      <template slot="last_login" slot-scope="props">
        <div>
          {{ moment(props.rowData.last_login).format('L') }}
        </div>
      </template>
      <template slot="date_joined" slot-scope="props">
        <div>
          {{ moment(props.rowData.date_joined).format('L') }}
        </div>
      </template>
      <template slot="actions" slot-scope="props">
        <div>
          <va-button @click="deleteItem = props.rowData.id" icon="entypo entypo-cancel" color="danger"
            :disabled="loading">{{ $t("users.delete") }}</va-button>
          <va-button v-if="!props.rowData.is_banned" @click="blockingUser(props.rowData.id)" icon="entypo entypo-block"
            color="danger" :disabled="loading">{{ $t("users.buttonBlock") }}</va-button>

          <va-button v-else @click="unBlockingUser(props.rowData.id)" icon="va-icon fa fa-check-circle-o"
            color="success" :disabled="loading">{{ $t("users.unButtonBlock") }}</va-button>

          <router-link :to="{ name: 'user-single', params: { id: props.rowData.id } }">
            <va-button>{{ $t("users.more") }}</va-button>
          </router-link>
        </div>
      </template>
    </va-data-table>
    <va-modal :value="deleteItem !== null" :title="$t('users.removeTitle')" :okText="null" :cancelText="''"
      :message="''" @cancel="deleteItem = null" noOutsideDismiss large>
      <form-delete :style="{ minWidth: '320px' }" @cancel="deleteItem = null" :cancel="true" :user-id="deleteItem"
        @submit="deletingUser" />
    </va-modal>
  </va-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formDelete from './FormDelete.vue'
import { debounce } from 'lodash'
import moment from 'moment'
export default {
  data() {
    return {
      deleteItem: null,
      skipLoading: false,
      searchBy: '',
      searchValue: '',
    }
  },
  components: { formDelete },
  computed: {
    ...mapState({
      loading: state => state.Users.isLoading,
      limit: state => state.Users.params.limit,
      totalPages: state => state.Users.total_pages,
      items: state => state.Users.items,
      page: state => state.Users.params.page,
      ordering: state => state.Users.params.ordering,
      usersTotal: state => state.Users.total_objects,
    }),
    orderBy: {
      get() {
        return (
          this.fields.find(
            el => el.name.replace('__slot:', '') === this.ordering,
          ) ?? {}
        )
      },
      set(value = {}) {
        this.readItems(this.page, this.limit, value.name)
      },
    },
    perPage: {
      get() {
        return this.limit + ''
      },
      set(value) {
        this.readItems(1, value)
      },
    },
    fields() {
      return [
        {
          name: '__slot:avatar',
          width: '60px',
        },
        {
          name: 'first_name',
          title: this.$t('users.first_name'),
        },
        {
          name: 'last_name',
          title: this.$t('users.last_name'),
        },
        {
          name: 'email',
          title: this.$t('users.email'),
        },
        {
          name: '__slot:last_login',
          title: this.$t('users.last_login'),
        },

        {
          name: '__slot:date_joined',
          title: this.$t('users.date_joined'),
        },
        {
          name: 'phone',
          title: this.$t('users.phone'),
        },
        {
          name: 'location',
          title: this.$t('users.location'),
        },
        {
          name: '__slot:profits',
          title: this.$t('users.profits'),
        },
        {
          name: 'lender_rating',
          title: this.$t('users.lender_rating'),
        },
        {
          name: 'borrower_rating',
          title: this.$t('users.borrower_rating'),
        },
        {
          name: 'count_of_publications',
          title: this.$t('users.count_of_publications'),
        },
        {
          name: '__slot:actions',
          title: this.$t('users.totalCount') + this.usersTotal,
          width: '60px',
          dataClass: 'text-center action-button',
        },
      ]
    },
  },
  watch: {
    searchValue: debounce(function () {
      this.readItems(1)
    }, 500),
    searchBy: function () {
      if (typeof this.searchBy === 'object') {
        this.searchBy = ''
      }
    },
  },
  created() {
    this.readItems()
  },
  methods: {
    moment,
    ...mapActions('Users', ['getItems', 'block', 'unBlock', 'deleteUser', 'getSvcUsers']),
    async readItems(
      page = this.page,
      limit = this.limit,
      ordering = this.ordering,
      searchBy = this.searchBy,
      searchValue = this.searchValue,
    ) {
      const req = { limit, page, ordering }
      if (searchBy && searchValue) {
        req[searchBy] = searchValue
      }

      const res = this.getItems(req)
      this.$nextTick(() => {
        this.$refs.vuetable.currentPage = page
      })
      return res
    },
    async blockingUser(id) {
      this.skipLoading = true
      const res = await this.block({
        id,
        data: { description: 'Block from list' },
      })
      if (res.data?.ok) {
        await this.readItems()
        this.showToast(res.data?.ok, {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 2500,
          fullWidth: false,
        })
      }
    },
    async deletingUser({ data, clear }) {
      const ask =
        data?.deleting &&
        confirm('Are you sure? Do you want to delete this user?')
      this.skipLoading = true

      if (ask || !data?.deleting) {
        const res = await this.deleteUser(data)
        if (res.data?.detail) {
          alert(res.data?.detail)
        }

        if (res.data?.ok) {
          await this.readItems()
          this.showToast(res.data?.ok, {
            icon: 'fa-check',
            position: 'bottom-right',
            duration: 2500,
            fullWidth: false,
          })
        } else {
        }
        clear()
        this.deleteItem = null
        this.skipLoading = false
      }
      // this.$router.go(-1)
    },
    async unBlockingUser(id) {
      this.skipLoading = true
      const res = await this.unBlock(id)
      if (res.data?.ok) {
        await this.readItems()
        this.showToast(res.data?.ok, {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 2500,
          fullWidth: false,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.users__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.action-button {
  white-space: nowrap;
}

.serchby {
  min-width: 120px;

  @media (max-width: 700px) {
    min-width: 150px;
  }

  @media (max-width: 400px) {
    min-width: 100px;
  }

  .va-select {
    border-bottom: none;
    border-right-width: 1px;
    border-top-right-radius: 0;
  }
}

th.vuetable-th-slot-actions {
  font-size: 30px;
  text-align: right;
  color: var(--va-textColor);
}
</style>
